import { useEffect, useRef } from "react";

import { getScrollParent } from "@smartrent/utils";

import type { RefObject } from "react";

export function useScrollLock(targetRef: RefObject<any>, locked: boolean) {
  const affected = useRef(false);
  useEffect(() => {
    const scrollParent = getScrollParent(targetRef.current);

    if (!scrollParent) {
      return;
    }

    const previousValue = scrollParent.style.getPropertyValue("overflow-y");
    if (locked) {
      const scrollbarWidth =
        scrollParent.offsetWidth - scrollParent.clientWidth;
      affected.current = true;
      scrollParent.style.setProperty("overflow-y", locked ? "hidden" : "auto");
      scrollParent.style.setProperty(
        "padding-right",
        locked ? `${scrollbarWidth}px` : "0px"
      );
    }

    return () => {
      if (affected.current === true) {
        scrollParent.style.setProperty("overflow-y", previousValue);
        scrollParent.style.setProperty("padding-right", "0px");
      }
    };
  }, [locked, targetRef]);
}
